<template>
  <div :class="['container', 'drawer-city-select', `${page_style}`]">
    <div class="drawer-wraper" @click="showCity">
      <span class="title">{{formItem.title}}</span>
      <p class="select-input">
        <span :class="['value-input', {'in-value': formatValue}]">{{formatValue || (isFleetFunnel ? formItem.placeholder || formItem.title : "")}}</span>
        <span class="info-arrow"></span>
      </p>
    </div>
    <p
      :class="['status-tip','tip_'+formItem.field_status]"
      v-show="formItem.field_result"
    >{{formItem.field_result}}</p>
    <single-page-city
      ref="singlePageCity"
      @close="closeCity"
      :self-close="true"
      :fleet-open-city="fleetOpenCity"
      :ob_driver_id="ob_driver_id"
      :page_style="page_style"
      :placeholder="formItem.placeholder"
      :item="formItem"
      class="page-container"
      :class="{t0:showPage,t100:!showPage}"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../../tools/request";
import { emitFormUpdate } from "../../tools/utils";
import SinglePageCity from "./singlepage-city";
import { AREA_TYPE } from "../../tools/constant";
export default {
  props: ["formItem", "idx", "cm", "ob_driver_id", "page_style"],
  components: { SinglePageCity },
  mounted() {
    // 如果当前组件有城市传入, 同步更新vuex
    if (this.formItem.value) {
      this.setState({
          [this.areaType.state]: {
            value: this.formItem.value,
            text: this.formItem.text,
          }});
    }
    // 如果当前组件无城市传入，则自动定位当前城市
    if (!this.formItem.value && !this._area.value) {
      this.getLocation();
    } else {
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
    }
    if (['2', '13'].includes(this._identity) && this.country === 'BR') {
      this.getFleetCityOpen()
    }
  },
  computed: {
    ...mapState(["_ticket", "_area", "_city", "_uuid", "_identity"]),
    params() {
      return new URLSearchParams(location.search);
    },
    country() {
      return this.params.get("location_country");
    },
    formatValue() {
      return this.formItem.text || this[this.areaType.state].text;
    },
    formItemtext() {
      return this.formItem.text
    },
    isFleetFunnel() {
      return ["h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    areaType() {
      return AREA_TYPE[this.formItem.type];
    }
  },
  data() {
    return {
      showPage: false,
      fleetOpenCity: []
    };
  },
  methods: {
    ...mapMutations(["setState"]),
    showCity() {
      //已通过则不再允许做操作
      if (this.formItem.field_status == 4) {
        return;
      }
      if (this.page_style !== 'h5_funnel_fleet_pc') {
        this.showPage = true;
        // @20210604 进入城市列表的时候固定在顶部
        try {
          this.$nextTick(() => {
            this.$refs.singlePageCity.$el.scrollIntoView();
          });
        } catch (e) {}
      }

      Omega.trackEvent("ibt_driver_basicinfo_city_click_ck", "", {
        ibt_crm_uid: this._uuid
      });
    },
    closeCity() {
      if (this.formItem.text) {
        this.formItem.text = this._area.text;
      }
      this.formItem.value = this._area.value;
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
      this.showPage = false;
    },
    setLocateCity(lng, lat) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (!up.get("lng")) {
        up.set("lng", lng);
        up.set("lat", lat);
      }
      post(process.env.GETCITY_URL, up)
        .then(data => {
          this.formItem.value = data.value;
          this.setState({ _area: data, _open_type: data.open_type }); //同步更新vuex
          this.formItem.valid = true;
          emitFormUpdate(this, this.idx);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getLocation() {
      let lng = this.params.get("lng"),
        lat = this.params.get("lat");
      if (lng && lat) {
        this.setLocateCity(lng, lat);
      } else {
        let that = this;
        /**
         *  获取经纬度信息
         *  position_option 获取经纬度信息的配置项
         *  getPositionSuccess 信息获取成功函数
         *  getPositionError 信息获取失败函数
         */
        let position_option = {
          enableHighAccuracy: true, //告诉浏览器是否启用高精度设备
          maximumAge: 30000, //单位毫秒，告诉设备缓存时间，主要用于设备的省电或者节省带宽方面
          timeout: 3000 //超时时间
        };
        navigator.geolocation.getCurrentPosition(
          getPositionSuccess,
          getPositionError,
          position_option
        );
        function getPositionSuccess(position) {
          that.setLocateCity(
            position.coords.longitude,
            position.coords.latitude
          );
        }
        function getPositionError(e) {
          console.log(e, "get position fail!");
        }
      }
    },
    checkCommit(...a) {
      this.formItem.value = a[0][0];
      this.setState({ _area: { value: a[0][0], text: a[2][0] } });
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
      //if need add
      if (this.cm) {
        this.addInfo();
      }
    },
    //提交物料
    addInfo() {
      // 更新icon --checking
      this.formItem.field_status = 3;
      this.formItem.field_result = this.$t("检测中");
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = this.formItem.value;
      if (this.formItem.clear_format) {
        val = this[this.formItem.format](val, true);
      }
      up.append(this.formItem.key, val);
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          // success do nothing
        })
        .catch(err => {
          this.formItem.field_status = 5;
          this.formItem.field_result = err.errmsg;
        });
    },
    // @20220215 巴西fleet开城
    getFleetCityOpen() {
      let up = new URLSearchParams(location.search);
      post(process.env.GET_FLEET_CITY, up)
        .then(data => {
          this.fleetOpenCity = data.list || [];
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-right: 0.36rem;
  margin-bottom: 0.1rem;
  font-size: 0.36rem;
  color: #414141;
  background: #fff;
}
.status-tip {
  width: 7.1rem; //铺满右侧
  margin-right: 0;
}
.drawer-wraper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 1.4rem;
  p {
    max-width: 70%;
    display: flex;
    align-items: center;
    color: #323233;
  }
}
.t0 {
  transform: translateX(0) !important;
}
.t100 {
  transform: translateX(100%) !important;
}
.page-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  // overflow: auto;
  // -webkit-overflow-scrolling: touch;
  background: #fff;
  transition: all 0.4s ease;
  transform: translateX(100%);
}
.drawer-city-select.h5_funnel_fleet,
.drawer-city-select.h5_funnel_fleet_pc {
  .drawer-wraper {
    flex-direction: column;
    justify-content: center;
    align-items: normal;
    .title {
      font-size: .24rem;
      color: #666666;
      font-weight: 500;
      line-height: 0.26rem;
    }
    .select-input {
      justify-content: space-between;
      padding: 0.32rem 0;
      width: 100%;
      max-width: 100%;
      border-bottom: 0.01rem solid #EEEEEE;
      transform: none;
      .value-input {
        font-size: .32rem;
        font-weight: 700;
        color: #CCCCCC;
      }
      .in-value {
        color: #333333;
      }
      .info-arrow {
        border-right-color: #666666;
        border-bottom-color: #666666;
      }
    }
  }
}
.drawer-city-select.h5_funnel_fleet_pc {
  padding: 0 32px 0 32px;
  position: relative;
  .drawer-wraper {
    min-height: 76px;
    .title {
      font-size: 12px;
      line-height: 13px;
      font-weight: 500;
    }
    .select-input {
      padding: 16px 0;
      border-bottom: 1px solid #EEEEEE;
      .value-input {
        font-size: 16px;
        font-weight: 700;
        opacity: 0;
      }
    }
  }
  .page-container {
    position: relative;
    transform: none !important;
  }
}
</style>
